export function fmtIDR(n: number): string {
    return 'Rp ' + Math.round(n).toLocaleString('id-ID');
}

export function fmtNum(n: number): string {
    return Number(n || 0).toLocaleString('id-ID');
}

export function fmtBytes(bytes: number): string {
    if (!bytes) return '0 KB';
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    if (bytes < 1024 ** 3) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    return `${+(bytes / 1024 ** 3).toFixed(1)} GB`;
}

/** "Updated 2 hours ago" — the phrasing the design uses on project and media rows. */
export function fmtUpdated(iso: string | undefined, prefix = 'Updated'): string {
    if (!iso) return `${prefix} recently`;
    const then = new Date(iso).getTime();
    if (Number.isNaN(then)) return `${prefix} recently`;
    const diff = Math.max(0, Date.now() - then);
    const min = Math.floor(diff / 60_000);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    const week = Math.floor(day / 7);
    if (min < 1) return `${prefix} just now`;
    if (min < 60) return `${prefix} ${min} minute${min === 1 ? '' : 's'} ago`;
    if (hr < 24) return `${prefix} ${hr} hour${hr === 1 ? '' : 's'} ago`;
    if (day === 1) return `${prefix} yesterday`;
    if (day < 7) return `${prefix} ${day} days ago`;
    if (week === 1) return `${prefix} last week`;
    if (week < 5) return `${prefix} ${week} weeks ago`;
    return `${prefix} ${new Date(iso).toLocaleDateString('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })}`;
}
